import React from 'react'

const Main = () => {
    return (
        <section>
            <hr className="line"/>
            <div className="max-container main_comp">
                <div className="story_card">
                    <h2>
                        Our <span className="magic_text">story</span>
                    </h2>
                    <p className="main_text">
                        In the boundless realm of software craftsmanship, our company stands as a beacon of
                        unwavering motivation, driven by an insatiable passion to transcend technological frontiers,
                        weave elegant code tapestries, and elevate user experiences to unprecedented heights.
                    </p>
                </div>
                <div id="cards">
                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">Machine Learning</span>
                            <p className="card_content">PyTorch<br/>TensorFlow</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">Database Management</span>
                            <p className="card_content">PostgreSQL</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">Frameworks</span>
                            <p className="card_content">Django<br/>Vue.js</p>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">DevOps</span>
                            <p className="card_content">Docker<br/>Kubernetes</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">Web Development</span>
                            <p className="card_content">React<br/>JavaScript</p>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card_border"></div>
                        <div className="inner_card">
                            <span className="card_title">Deep understanding of</span>
                            <p className="card_content">Java<br/>Python</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.jsx